import axiosKigagu from 'axios'
import axios from '@/libs/axios'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    userdata: {
      email: '',
      password: '',
    },
    user: {},
    token: null,
    baseUrl: (process.env.VUE_APP_KIGAGU_API_BASE_URL || 'https://api.kigagu.com/api'),
  },
  getters: {
    _user(state) {
      return state.user
    },
    _token(state) {
      return state.token
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setToken(state, token) {
      state.token = token
    },
  },
  actions: {
    async ensureToken(context) {
      let token = context.getters._token

      if (!token) {
        try {
          await context.dispatch('login')
        } catch (error) {
          console.error('Kigagu login error:', error)
        }
        token = context.getters._token
      }

      if (!token) {
        Vue.swal({
          title: 'Giris Hatasi',
          icon: 'error',
          text: 'Kigagu girisi yapilamadi. Lutfen tekrar deneyiniz.',
        })
        return null
      }

      return token
    },
    login(context) {
      return axios.get('/v2/kigagu/auth')
        .then(res => {
          const { data } = res
          context.state.userdata.email = data.email
          context.state.userdata.password = data.password
          
          const baseUrl = context.state.baseUrl || ''
          return axiosKigagu.post(`${baseUrl}/auth/login`, context.state.userdata)
        })
        .then(res => {
          const { data } = res
          context.commit('setUser', data.user)
          context.commit('setToken', data.user.accessToken)
        })
    },
    logout(context) {
      context.commit('setUser', {})
      context.commit('setToken', null)
    },
  },
}
